var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStethoscope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext3_2",
    x: 0.908203,
    width: 40,
    height: 40,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M12.3567 10.25H13.4222C13.8288 10.25 14.1582 10.5857 14.1582 11C14.1582 11.4143 13.8288 11.75 13.4222 11.75H12.2832C11.9202 11.75 11.9082 11.9375 11.9082 12.125V14H11.9135C11.909 14.0845 11.912 15.4468 11.9131 15.9592C11.9133 16.0384 11.9121 16.2068 11.9115 16.25L10.4082 16.25V12.2085C10.4082 11.1282 11.2819 10.25 12.3567 10.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M10.422 17C10.5468 19.9058 12.1954 21.9006 14.9082 22.2084V25.7165C14.9082 28.3498 16.8452 30.5 19.4082 30.5C21.9712 30.5 23.9082 28.3576 23.9082 25.7165V23C23.9082 21.4355 24.5858 20.75 26.1582 20.75C27.4562 20.7501 28.1926 21.2076 28.3674 22.3929C27.5149 22.713 26.9082 23.5356 26.9082 24.5C26.9082 25.7426 27.9156 26.75 29.1582 26.75C30.4008 26.75 31.4082 25.7426 31.4082 24.5C31.4082 23.5028 30.7595 22.6571 29.861 22.3619C29.5903 20.568 28.1758 19.2619 26.1582 19.25C23.962 19.2371 22.4082 20.75 22.4082 23.0754V25.7165C22.4082 27.4305 21.0715 29 19.4082 29C17.7449 29 16.4082 27.4305 16.4082 25.7165V22.2091C19.1236 21.9033 20.7699 19.9078 20.8994 17H19.375C19.1415 19.5 17.7124 20.75 15.6611 20.75C13.6097 20.75 12.1884 19.5 11.9473 17H10.422ZM29.1582 25.625C28.5369 25.625 28.0332 25.1213 28.0332 24.5C28.0332 23.8787 28.5369 23.375 29.1582 23.375C29.7795 23.375 30.2832 23.8787 30.2832 24.5C30.2832 25.1213 29.7795 25.625 29.1582 25.625Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M19.4087 16.25H20.9086C20.9103 15.5663 20.9134 14.1842 20.9082 14.0126V12.2085C20.9082 11.1282 20.0345 10.25 18.9597 10.25H17.8942C17.4876 10.25 17.1582 10.5857 17.1582 11C17.1582 11.4143 17.4876 11.75 17.8942 11.75H19.0332C19.3962 11.75 19.4082 11.9375 19.4082 12.125L19.4087 16.25Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/Stethoscope.f1c2c52b.svg";
export { ForwardRef as ReactComponent };